<snelstart-ui-button (click)="this.showDialog()"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<form [formGroup]="omzetbelastingPassivaFg">
    <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg"
                                    title="Specificatie te betalen omzetbelasting slotbalans">
        <snelstart-ui-dialog-header-content>
            Geef aan op welke jaren het bedrag van de eindbalans betrekking heeft.
        </snelstart-ui-dialog-header-content>
        <snelstart-ui-dialog-body>
            <div class="row pt-2 ps-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="me-1 custom-input-150 custom-input-readonly"
                                                  formControlName="waardeSlot"
                                                  label="Slotbalans"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>

                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="omzetbelastingDitBoekjaar"
                                                  label="Dit boekjaar"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>

                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="omzetbelastingVorigBoekjaar"
                                                  label="Vorig boekjaar"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>

                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="omzetbelastingOudereBoekjaren"
                                                  label="Oudere boekjaren"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
        </snelstart-ui-dialog-body>
        <snelstart-ui-dialog-buttons class="d-flex">
            <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
            <snelstart-ui-button (click)=saveForm() icon="check" id="save2" type="primary">
                Opslaan
            </snelstart-ui-button>
        </snelstart-ui-dialog-buttons>

    </snelstart-ui-dialog-definition>

</form>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
